import { createFocusTrap } from 'focus-trap'; // ESM
import disableScroll from 'disable-scroll';

export default {
    //when the user clicks the Opt in button we should check the tickbox,
    //if any other dev reads this, the label is not for for the tickbox.
    //That's why it needs to be done like this, silly Caldera Forms.
    init: function() {
        this.steps();
        let modal = document.querySelector('.start-living');
        if(modal) {
            // disableScroll.off(modal);
            let focus = createFocusTrap('.start-living');
            focus.activate();
        }

        let label = document.getElementById('fld_1039073Label');
        let checkbox = document.getElementById('fld_1039073_1_opt1680112');

        if(label && checkbox) {
            label.addEventListener('click', () => {
                checkbox.checked = !checkbox.checked;
            })
        }

        // document.querySelectorAll

        let inputs = document.querySelectorAll('.checkbox input');
        inputs.forEach((input, i) => {
            // input.tabIndex = i + 1;
            input.addEventListener('keydown', e => {
                if (e.keyCode === 13) {
                    input.checked = !input.checked;
                    e.preventDefault();
                } 
            })

            input.addEventListener('click', e => {
                document.activeElement.blur();
            })
        })

        let submit_wrapper = document.querySelector('#fld_4685491_1-wrap');
        if(submit_wrapper) {
            let submit_btn = submit_wrapper.querySelector('input');
            
            submit_btn.tabIndex = -1;
            submit_wrapper.tabIndex = 0;

            submit_wrapper.addEventListener('focus', (e) => {
                submit_btn.classList.add('dark');
            })

            submit_wrapper.addEventListener('focusout', (e) => {
                submit_btn.classList.remove('dark');
            })

            submit_wrapper.addEventListener('mouseover', (e) => {
                submit_btn.classList.add('dark');
            });

            submit_wrapper.addEventListener('mouseleave', (e) => {
                submit_btn.classList.remove('dark');
            })

            submit_wrapper.addEventListener('click', (e) => {
                submit_btn.click();
            })

            submit_wrapper.addEventListener('keydown', (e) => {
                if (e.keyCode === 13) {
                    submit_btn.click();
                }
            })
        }
    },

    //TODO: Change current step to 1 when key hill reintroduced
    currentStep: 2,
    steps: function() {
        //getting the caldera grids on a page.
        let grid = document.querySelector('.caldera-grid');
        //if the page has a form
        if(grid) {
            //the enbankment & key hill buttons.

            //TODO: uncomment this code when key hill is re-introduced.

            // let step1Btns = document.querySelectorAll('#fld_3442133_1_opt1864228, #fld_3442133_1_opt1681840');
            // step1Btns.forEach(btn => {
            //     let fieldset = btn.closest('.form__group');
            //     fieldset.classList.add('visible');
            //     this.stepButtons(btn, 1, fieldset.nextElementSibling);
            // })

            let step2Btns = document.querySelectorAll("#fld_1834237_1_opt1951082, #fld_1834237_1_opt1737444");


            step2Btns.forEach(btn => {
                //TODO: remove the lines below when key hill reintroduced
                let fieldset = btn.closest('.form__group');
                    fieldset.classList.add('visible');

                //DONT DELETE THIS!!!!
                let remainingElements = document.querySelectorAll("#fld_1834237_1-wrap ~ *");
                this.stepButtons(btn, 2, remainingElements);
            })

        }
    },
    /**
     * If we have Selected a button, show the next step and scroll down to the next fieldset.
     * @param {Element} btn The button that is pressed
     * @param {number} step The step this button corresponds with
     * @param {Element|NodeList} elementToShow Element to reveal on form progression.
     */
    stepButtons: function(btn, step, elementToShow) {
        btn.addEventListener('change', e => {

            if(this.currentStep === step) {
                console.log('Step ' + step + ' complete');
                this.currentStep = this.currentStep + 1;
                //if this is a nodelist then iterate else add to the element
                if(elementToShow instanceof NodeList) {
                    elementToShow.forEach(el => {
                        el.classList.add('visible');
                    })
                    let scrollEl = elementToShow[elementToShow.length - 1];
                    //element to scroll to.
                    elementToShow.forEach(el => {
                        let display = window.getComputedStyle(el, null).display;
                        if(display !== 'none') {
                            scrollEl = el;
                        }
                    })
                    scrollEl.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                } else {
                    elementToShow.classList.add('visible');
                    elementToShow.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                }
            }
        })
    }
}